import { useEffect } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import EFVideo from '@/components/UI/EFVideo';

export default function Capture() {
    const { t } = useLang('powerstream');

    useEffect(() => {
        AniContainer.create({
            syncFromTo: [['.capture-section .video-box', { y: 0 }, { y: 300 }, 1]],
            triggerElement: '.capture-section',
            offset: '30%',
            duration: '170%',
            triggerHook: 1,
        });
    }, []);

    return (
        <div className={styles.capture}>
            {/* {locale === 'de' && (
                <Link className="img-box" href={`https://${locale}.ecoflow.com/pages/upgrade-program`}>
                    <NextImage src={require('@publicLocal/power-stream/detail/50€_gutschein_pc.jpg')} alt={t('title')} aria-label={t('title')} />
                </Link>
            )} */}
            <div className="capture-section">
                <div className="capture-text">
                    <p className="capture-title">{t.rich('detail.capture.title', { HighLight: (text: any) => <span className="green-text">{text}</span> })}</p>
                    <p className="capture-desc">{t('detail.capture.desc')}</p>
                </div>
                <div className="ani-box">
                    <div className="video-box">
                        <EFVideo
                            className="capture-video"
                            sources={['/media/power-stream/detail/pc/capture.webm', '/media/power-stream/detail/pc/capture.mp4']}
                            autoPlay={true}
                            loop={true}
                            muted={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
